<template>

  <div>
    <!--活动列表-->
    <Index v-if="activeName == 'index'"></Index>
    <Equip v-if="activeName == 'equip'"></Equip>
    <Cash v-if="activeName == 'cash'"></Cash>
    <Log v-if="activeName == 'log'"></Log>
    <Service v-if="activeName == 'service'"></Service>
     <!-- <Belong v-if="activeName == 'belong'"></Belong> -->
    <!-- <Setting v-if="activeName == 'setting'"></Setting> -->
  </div>  
</template>
<script>
import bus from '@/utils/eventBus.js';
import Index from './filiale/index';
import Setting from './setting/getSetting';
import Equip from './../equip/equip/belong';
import Belong from './../equip/equip/belong';
import Cash from './../agent/cash/Cash';
import Service from './../service/service/index';
import Log from './../equip/equip/log';
export default {
  components: {
    Index,
    Setting,
    Equip,
    Belong,
    Cash,
    Service,
    Log
  },
  data() {
    return {
      formInline: {
        nick_name: ''
      },
      /*参数*/
      param: {},
      /*当前选中*/
      activeName: 'index',
      /*切换数组*/
      sourceList: [
        {
          key: 'index',
          value: '招商中心列表',
          path:'/plus/filiale/filiale/index'
        },
        {
          key: 'service',
          value: '服务商管理',
          path:'/plus/service/service/index'
        },
        {
          key: 'equip',
          value: '设备列表',
          path:'/plus/equip/equip/belong'
        },
        {
          key: 'log',
          value: '收入明细',
          path:'/plus/equip/equip/log'
        },
        {
          key: 'cash',
          value: '提现明细',
          path:'/plus/agent/index?type=cash'
        },

        // {
        //   key: 'belong',
        //   value: '所属记录',
        //   path:'/plus/filiale/filiale/belong'
        // },
        // {
        //   key: 'setting',
        //   value: '回访设置',
        //   path:'/plus/filiale/setting/getSetting'
        // },
       
      ],
      /*权限筛选后的数据*/
      tabList:[],
      /*判断third是否有参数*/
      is_third_param: false
    };
  },
  watch:{

    //监听路由
    $route(to, from) {
      this.init();
    }
  },
  created() {

    this.init();

  },
  beforeDestroy() {
    //发送类别切换
    console.log("触发了吗")
   
    bus.$emit('tabData', { active: null, tab_type:'activity',list: [] });
      bus.$off('activeValue');

  },
  methods: {

    /*初始化方法*/
    init(){
      this.tabList=this.authFilter();

      if(this.tabList.length>0){
        this.activeName=this.tabList[0].key;
        // console.log("this.tabList",this.tabList)
        // bus.$emit('tabData', { active: this.activeName, tab_type:this.activeName,list: this.tabList });
      }

      if (this.$route.query.type != null) {
        var ind = 0;
        //需要检测是否在tablist里有出现
        for(var i=0;i<this.tabList.length;i++){
            if(this.tabList[i].key == this.$route.query.type){
              ind++;
            }
        }
        if(ind<= 0){
          this.activeName = this.tabList[0].key;
        }else{
          this.activeName = this.$route.query.type;
        }
       
      }

      /*监听传插件的值*/
      bus.$on('activeValue', res => {
        console.log("res",res)
        let self = this;
          self.$router.push({
            path: '/plus/filiale/index',
            query: {
              type: res
            }
          });

        if (this.is_third_param) {
          this.param.user_id = '';
          this.is_third_param = false;
        }
        this.activeName = res;
      });

      //发送类别切换
      let params = {
        active: this.activeName,
        list: this.tabList,
        tab_type:'index'
      };
      bus.$emit('tabData', params);
    },

    /*权限过滤*/
    authFilter(){
      let list=[];
      for(let i=0;i<this.sourceList.length;i++){
        let item=this.sourceList[i];
        if(this.$filter.isAuth(item.path)){
          list.push(item);
        }
      }
      return list;
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/filiale/index.vue